import { ClientActionTypes } from '../client.action-types'

const initialStates = {
    item: {},
    instructionLetter: [],
}
const MyVaultReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case ClientActionTypes.GET_ITEM_STOLEN_OR_LOST:
            return {
                ...state,
                item: action.payload,
            }
        case ClientActionTypes.GET_INSTRUCTION_LETTER:
            return {
                ...state,
                instructionLetter: action.payload,
            }
        default:
            return { ...state }
    }
}

export default MyVaultReducer
